


import ILanguageDto from "@workspace/apiservice/src/model/LanguageDto.if";
import { ILanguageSelectItemViewModel, ILanguageSelectViewModel } from "../../components/languageselect/interface";
import { IBaseControllerRenderResult } from "../interface";


export interface IRouteLanguageSelectArguments {
    db: string;
    sessionName: string;
}

export interface ILanguageSelectControllerProps {
    didRequestTourSelect: (languageId: number) => void;
    didRequestBack: () => void;
    route: IRouteLanguageSelectArguments;
}

export interface ILanguageSelectControllerRenderResult extends IBaseControllerRenderResult<{language: ILanguageDto}> {}

export interface ILanguageSelectController {
}

export interface ILanguageSelectItemControllerModel extends ILanguageSelectItemViewModel {
}

export interface ILanguageSelectControllerModel extends ILanguageSelectViewModel {
    cycler: any;
    activeTitle: () => string;
    nextTitle: () => string;
    delayBetweenChangingTitle: number;
}

export enum ILanguageSelectType {
    Undef = 0,
    List = 1,
    GridFlag = 2,
    GridTile = 3,
    LastValue = 4,
}
